import React from "react";

import { tw } from "~/utils";

interface RadioCardOption {
  value: string;
  label: string;
  description?: string;
}

interface RadioCardGroupProps {
  options: RadioCardOption[];
  value: string | null | undefined;
  onChange: (value: string) => void;
  columns?: 1 | 2;
  disabled?: boolean;
}

export const RadioCardGroup: React.FC<RadioCardGroupProps> = ({
  options,
  value,
  onChange,
  columns = 1,
  disabled = false,
}) => {
  return (
    <div
      className={tw(
        "grid w-full gap-3",
        columns === 1 && "grid-cols-1",
        columns === 2 && "xs:grid-cols-2 grid-cols-1",
      )}
    >
      {options.map((option) => {
        const isSelected = value === option.value;

        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            disabled={disabled}
            className={tw(
              "flex w-full cursor-pointer items-center rounded-lg border-2 p-4 text-left transition-all",
              isSelected && "border-green-500 bg-green-50",
              !isSelected &&
                !disabled &&
                "border-gray-200 hover:border-gray-300 hover:bg-gray-50",
              disabled && "cursor-not-allowed opacity-50",
            )}
          >
            {/* Radio indicator */}
            <div
              className={tw(
                "mr-3 flex size-5 shrink-0 items-center justify-center rounded-full border-2 transition-all",
                isSelected ? "border-green-500" : "border-gray-300",
              )}
            >
              {isSelected && (
                <div className="size-2.5 rounded-full bg-green-500" />
              )}
            </div>

            {/* Label and description */}
            <div className="flex flex-col">
              <span className="text-base font-medium text-gray-900">
                {option.label}
              </span>
              {option.description && (
                <span className="mt-0.5 text-sm text-gray-500">
                  {option.description}
                </span>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default RadioCardGroup;
